import React from "react";
import { Control, FieldErrors } from "react-hook-form";
import { FormMultiselectDropdown, FormMultiselectDropdownRules, getById, mapToDropdownOption } from "sprint-common-web";

import { useDynamicSubtitles } from "../../../../common/data/data-hooks/useDynamicSubtitles";
import { useCreateOrder } from "../common/provider/useCreateOrder";
import { isCleanVideoEmbeddedSubtitle } from "../common/subtitles/subtitles";

interface OrderDynamicSubtitlesSelectorProps {
    label: string;
    name: string;
    control: Control;
    errors: FieldErrors;
    dependsOn: string[];
    testId?: string;
    rules?: FormMultiselectDropdownRules;
}

export const OrderDynamicSubtitlesSelector = ({
    label,
    name,
    control,
    errors,
    dependsOn,
    testId,
    rules
}: OrderDynamicSubtitlesSelectorProps): JSX.Element => {
    const { data: subtitleLanguages } = useDynamicSubtitles();
    const { setDynamicSubtitles, embeddedSubtitle } = useCreateOrder();

    const handleSelectedOption = (ids: string[]) => {
        const currentSubtitles = ids.map((id, index) => {
            const language = getById(subtitleLanguages ?? [], id);

            return {
                ...language,
                index: index + 1,
                isEmbedded: false
            };
        });

        setDynamicSubtitles(currentSubtitles);
    };

    return (
        <FormMultiselectDropdown
            label={label}
            placeholder="Search and select subtitles"
            name={name}
            options={subtitleLanguages?.map((item) => mapToDropdownOption(item)) ?? []}
            control={control}
            errors={errors}
            dependsOn={dependsOn}
            onChange={handleSelectedOption}
            testId={testId}
            rules={rules}
            disabled={!isCleanVideoEmbeddedSubtitle(embeddedSubtitle)}
        />
    );
};
